module.exports = ['$scope', '$rootScope', '$translate', 'netFolderService', '$utils', '$ionicScrollDelegate', 'User',
  function ($scope, $rootScope, $translate, netFolderService, $utils, $ionicScrollDelegate, User) {
    let folderIdArr = ['root']
    const limit = 20
    init()
    $scope.selectedFiles = []
    // 初始化文件选择器
    function init() {
      $scope.rootDir = getRootEntrance()
      $scope.fileList = []
      $scope.folderId = 'root'
      $scope.folderType = 'root'
      $scope.curFolderName = $translate.instant('NETFOLDER.FOLDER_CENTER')
      $scope.isEmpty = false
      folderIdArr = ['root']
    }
    // 获取文件选择器根目录入口列表
    function getRootEntrance() {
      const rootDir = []
      const $ajc = User.getConfig()['$ajc']
      if (!$scope.netfolderConfig) {
        $scope.netfolderConfig = {
          hasPerNetfolder: $ajc['nf'] && $ajc['nf']['enabled'],
          hasEntNetfolder: $ajc['nf'] && $ajc['nf']['enfEnabled']
        }
      }
      if ($scope.netfolderConfig.hasEntNetfolder && $rootScope.settings.featureControl.fileCenter.enableSelectFromEnterpriseNetworkDisk) {
        rootDir.push({
          name: $translate.instant('NETFOLDER.ENT_NETFOLDER'),
          type: 'ent',
          id: 0,
          icon: 'icon-iconfilecompany'
        })
      }
      if ($scope.netfolderConfig.hasPerNetfolder && $rootScope.settings.featureControl.fileCenter.enableSelectFromPersonalNetworkDisk) {
        rootDir.push({
          name: $translate.instant('NETFOLDER.PERSONAL_NETFOLDER'),
          type: 'per',
          id: 0,
          icon: ' icon-iconfilepersonal'
        })
      }
      if ($rootScope.settings.featureControl.fileCenter.enableFileTransitCenter) {
        rootDir.push({
          name: $translate.instant('NETFOLDER.FILE_TRANSIT_CENTER'),
          type: 'ftc',
          id: 9,
          icon: 'icon-icon_transfer'
        })
      }
      if ($rootScope.settings.featureControl.fileCenter.enableRelatedAccessory) {
        rootDir.push({
          name: $translate.instant('NETFOLDER.RELATED_ACCESSORY'),
          type: 'rel',
          id: 0,
          icon: 'icon-icon_annex'
        })
      }
      return rootDir
    }
    // 进入文件夹
    $scope.goFolder = function (fid, type) {
      $scope.folderType = type || $scope.folderType
      fid = parseInt(fid || 0)
      $scope.folderList = []
      $scope.fileList = []
      $scope.isLoading = true
      if ($scope.folderType == 'ent') {
        netFolderService.getEntFolderList(fid, { isEntFolder: true }).then(function (data) {
          $scope.folderList = data['var'].children || []
          $scope.folderId = data['var'].id
          $scope.curFolderName = data['var'].name || $translate.instant('NETFOLDER.ENT_NETFOLDER')
          folderIdArr.push($scope.folderId)
          const opt = {
            uid: netFolderService.getUid(),
            start: 0,
            limit: limit,
          }
          getFileList($scope.folderId, opt)
        })
      } else if ($scope.folderType == 'per') {
        netFolderService.getFolderList(fid, {}).then(function (data) {
          $scope.folderList = data['var'].children || []
          $scope.folderId = data['var'].id
          $scope.curFolderName = data['var'].name || $translate.instant('NETFOLDER.PERSONAL_NETFOLDER')
          folderIdArr.push($scope.folderId)
          const opt = {
            start: 0,
            limit: limit
          }
          getFileList($scope.folderId, opt)
        })
      } else if ($scope.folderType == 'ftc') {
        $scope.folderId = 9
        $scope.curFolderName = $translate.instant('NETFOLDER.FILE_TRANSIT_CENTER')
        folderIdArr.push($scope.folderId)
        getFileList(fid, { start: 0, limit: limit })
      } else if (type == 'rel') {
        $scope.folderId = 'rel'
        $scope.curFolderName = $translate.instant('NETFOLDER.RELATED_ACCESSORY')
        folderIdArr.push($scope.folderId)
        getAttachmentList({ start: 0, limit: 20 })
      } else { // 跳到根目录
        init()
      }
      $utils.$uiHelper.scrollToTop('selectFileContent')
    }
    // 获取文件列表 （企业网盘， 个人网盘， 文件中转站）
    function getFileList(fid, options) {
      netFolderService.listFiles(fid, options).then(function (data) {
        if (data && data.code === 'S_OK') {
          if (data.var) {
            for (let i = 0; i < data.var.length; i++) {
              data.var[i].formattype = $utils.$attachment.getIconClass(data.var[i].name, data.var[i].contentType)
              if ($scope.folderType === 'ftc') {
                data.var[i].formatRemaintime = getFormatRemaintime(data.var[i].misc.remaintime)
                data.var[i].limitTime = getLimitTime(data.var[i].misc.remaintime)
              }
            }
            $scope.fileList = $scope.fileList.concat(data.var) || []
            $ionicScrollDelegate.resize()
            if ($scope.folderType == 'ent' || $scope.folderType == 'per') {
              $scope.isEmpty = $scope.folderList.length === 0 && $scope.fileList.length === 0
            } else if ($scope.folderType == 'ftc') {
              $scope.isEmpty = $scope.fileList.length === 0
            }
            if (data.var.length < limit || data.var == undefined) {
              $scope.noMoreFile = true
            } else {
              $scope.noMoreFile = false
            }
          }
        }
      }, function (error) {
        console.log(error)
      }).finally(function () {
        $scope.isLoading = false
      })
    }
    // 更多
    $scope.loadMore = function () {
      console.log('laodmore')
      const options = {
        start: $scope.fileList.length,
        limit: limit,
      }
      if ($scope.folderType == 'ent') {
        options.uid = netFolderService.getUid()
      }
      getFileList($scope.folderId, options)
    }
    // 格式化有效期 （有效期： 5天23时）
    function getFormatRemaintime(remainTime) {
      let days, hours
      if (remainTime % 86400000 > 0) {
        days = Math.floor(remainTime / 86400000)
      } else {
        days = 0
      }
      hours = Math.ceil(remainTime / 3600000 - (24 * days))
      if (hours === 24) {
        days += 1
        hours = 0
      }
      const time = $translate.instant('NETFOLDER.VALID_TIME', {days: days, hours: hours})
      return time
    }
    // 获取有效期 （5天内有效）
    function getLimitTime(remainTime) {
      let days
      if (remainTime % 86400000 > 0) {
        days = Math.ceil(remainTime / 86400000)
      } else {
        days = Math.floor(remainTime / 86400000)
      }
      return $translate.instant('NETFOLDER.VALIDITY_PERIOD', {days: days})
    }
    // 获取附件列表
    function getAttachmentList(options) {
      $scope.isLoading = true
      $scope.attachmentList = []
      netFolderService.listAttachments(options).then(function (data) {
        if (data && data.code === 'S_OK') {
          data.var.forEach(function (item) {
            item.formattype = $utils.$attachment.getIconClass(item.attn, item.contentType)
          })
          $scope.attachmentList = $scope.attachmentList.concat(data.var) || []
          $scope.isEmpty = $scope.attachmentList.length === 0
          $scope.noMoreAttachment = $scope.attachmentList.length === data.total
          $ionicScrollDelegate.resize()
        }
      }, function (error) {
        console.log(error)
      }).finally(function () {
        $scope.isLoading = false
      })
    }
    $scope.moreAttachment = function () {
      $scope.isLoadingMore = true
      const options = {
        start: $scope.attachmentList.length,
        limit: limit
      }
      netFolderService.listAttachments(options).then(function (data) {
        if (data && data.code === 'S_OK') {
          data.var.forEach(function (item) {
            item.formattype = $utils.$attachment.getIconClass(item.attn, item.contentType)
          })
          $scope.attachmentList = $scope.attachmentList.concat(data.var) || []
          $scope.isEmpty = $scope.attachmentList.length === 0
          $scope.noMoreAttachment = $scope.attachmentList.length === data.total
          $ionicScrollDelegate.resize()
        }
      }, function (error) {
        console.log(error)
      }).finally(function () {
        $scope.isLoadingMore = false
      })
    }
    // 返回
    $scope.goBack = function () {
      const index = folderIdArr.indexOf($scope.folderId)
      if (index > 1) { // 返回上一级
        $scope.goFolder(folderIdArr[index - 1], $scope.folderType)
        folderIdArr.pop()
        console.log(folderIdArr)
      }
      if (index === 1) { // 返回到根目录
        init()
        $utils.$uiHelper.scrollToTop('selectFileContent')
      }
    }

    $scope.cancel = function () {
      $scope.$emit('closeSelectModal', $scope.folderList)
    }

    $scope.selectFile = function (fileItem) {
      const index = $scope.selectedFiles.indexOf(fileItem)
      if (index !== -1) {
        $scope.selectedFiles.splice(index, 1)
        fileItem.selected = false
      } else {
        fileItem.selected = true
        switch ($scope.folderType) {
          case 'ent':
            fileItem._enfUid = netFolderService.getUid()
            fileItem.type = 'netfolder'
            break
          case 'per':
            fileItem.type = 'netfolder'
            break
          case 'ftc':
            fileItem.type = 'trs'
            break
          case 'rel':
            fileItem.type = 'internal'
            break
        }
        $scope.selectedFiles.push(fileItem)
      }
    }

    $scope.commitSelected = function () {
      // 向调用的父controller传递事件,表示选择完毕
      $scope.$emit('commitSelected', $scope.selectedFiles)
    }
  }]



// WEBPACK FOOTER //
// ./src/js/netFolder/selectFilesCtrl.js